import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { SidenavService } from './layout/sidenav/sidenav.service';
import { ThemeService } from '../@prep/services/theme.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { SplashScreenService } from '../@prep/services/splash-screen.service';
import { CrispWidgetService } from './widget/crisp-widget.service';
// import { UserIdleService } from 'angular-user-idle';

// Only the RSP Orders page ("/orders") owns the Crisp chat launcher/panel.
// RspOrdersComponent shows/hides it during its own lifecycle, but that relies
// on ngOnDestroy firing - if that ever gets skipped (fast route changes,
// route-reuse, etc.) the widget can stay visible after navigating away. This
// is a page-independent backstop: on every completed navigation, force the
// widget hidden unless we're still on the orders page.
const CRISP_ALLOWED_PATH = '/orders';
// Every logout path (manual, session expiry, 401) ends on the login page,
// so landing there is the single place to drop the user's Crisp session.
// Deliberately not gated on the auth token being gone: the 401 "logged in
// on another device" paths navigate here while leaving a stale token behind.
// A logged-in user who merely visits /login gets their session reset too —
// with a crisps_token, identify() restores the same history right after.
const LOGIN_PATH = '/login';

@Component({
  selector: 'prep-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private sidenavService: SidenavService,
    private iconRegistry: MatIconRegistry,
    private renderer: Renderer2,
    private themeService: ThemeService,
    @Inject(DOCUMENT) private document: Document,
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private crispWidgetService: CrispWidgetService,
    private splashScreenService: SplashScreenService,
    // private userIdle: UserIdleService
  ) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (!event.urlAfterRedirects.startsWith(CRISP_ALLOWED_PATH)) {
          this.crispWidgetService.hide();
        }
        // Exact path match (ignoring query/hash) so e.g. /login-ce doesn't count.
        const path = event.urlAfterRedirects.split(/[?#]/)[0];
        if (path === LOGIN_PATH) {
          this.crispWidgetService.clearSession();
        }
      });

    this.route.queryParamMap
      .pipe(filter((queryParamMap) => queryParamMap.has('style')))
      .subscribe((queryParamMap) =>
        this.themeService.setStyle(queryParamMap.get('style'))
      );

    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
    this.themeService.theme$.subscribe((theme) => {
      if (theme[0]) {
        this.renderer.removeClass(this.document.body, theme[0]);
      }

      this.renderer.addClass(this.document.body, theme[1]);
    });

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }
    this.sidenavService.items = [];
  }

  ngOnInit() {
    //Start watching for user inactivity.
    // this.userIdle.startWatching();
    
    // Start watching when user idle is starting.
    // this.userIdle.onTimerStart().subscribe(count => console.log(count));
    
    // Start watch when time is up.
    // this.userIdle.onTimeout().subscribe(() => {
    //   this. stopWatching();
    //   console.log('Time is up!');
    // });
  }

  // stop() {
  //   this.userIdle.stopTimer();
  // }

  // stopWatching() {
  //   this.userIdle.stopWatching();
  // }

  // startWatching() {
  //   this.userIdle.startWatching();
  // }

  // restart() {
  //   this.userIdle.resetTimer();
  // }
}
